<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Detalhados
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | A listagem
        strong  Detalhados
        |  mostra documentos em visão tabular ampliada para consulta.

      .toast.toast-primary
        | Exige a permissão
        strong  Fiscalização → Documentos detalhados → Listar
        | .

      h5.h5 1. Abrir Detalhados
      ol
        li Em
          strong  Doc
          | , clique em
          strong  Detalhados
          | .
      figure.manual-figure
        img(:src="imgLista" alt="Listagem Documentos detalhados")
      ol
        li Aplique filtros e paginação.
        li Clique em
          strong  Exibir
          |  para abrir o documento.
      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/18-doc-detalhados-lista.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
